import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["html", "className", "id", "name", "checked", "value", "onChange", "label", "hasError", "theme"];
import React from 'react';
import { Wrapper, CheckContainer, Input, Check, Text } from './styles';
import CheckIcon from '../Icons/Check';
import withTheme from '../theme/withTheme';

var _ref2 = /*#__PURE__*/React.createElement(CheckIcon, {
  width: "10px",
  height: "8px"
});

var Checkbox = function Checkbox(_ref) {
  var html = _ref.html,
      className = _ref.className,
      id = _ref.id,
      name = _ref.name,
      checked = _ref.checked,
      value = _ref.value,
      onChange = _ref.onChange,
      label = _ref.label,
      hasError = _ref.hasError,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Wrapper, {
    theme: theme,
    className: className
  }, /*#__PURE__*/React.createElement(CheckContainer, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Input, _extends({
    type: "checkbox",
    id: id,
    name: name,
    checked: checked,
    value: value,
    onChange: onChange,
    theme: theme
  }, rest)), /*#__PURE__*/React.createElement(Check, {
    hasError: hasError,
    theme: theme
  }, _ref2)), label && /*#__PURE__*/React.createElement(Text, {
    hasError: hasError,
    htmlFor: id,
    theme: theme
  }, label), html && /*#__PURE__*/React.createElement(Text, {
    hasError: hasError,
    htmlFor: id,
    theme: theme,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
};

Checkbox.defaultProps = {
  checked: false,
  onChange: function onChange() {}
};
export default withTheme(Checkbox);